
  export const reportIntervalOptions = [
    { label: "Daily", value: "daily" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];


  export const fillColors = ["#224CA5", "#FF4560", "#F9E001"];